module.exports = __webpack_public_path__ + "static/img/PCGA.06d893e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PCGA.png
// module id = qFMn
// module chunks = 1